import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { MessageConst } from 'enums'
import { useDisplayTheme } from 'hooks/useUiState'
import { getAuthorUrl } from 'utils/sourceUtil'
import Link from './Link'
import { useContextMediaDetail } from './context'

const Container = styled.div<{ mode: string }>`
  color: ${({ mode }) => sys[mode].text.placeholder};
  font-size: ${sys.typescale[14].size};
  line-height: ${sys.typescale[14].lineHeight};
  font-weight: ${sys.fontWeight.regular};
  display: flex;
  flex-wrap: wrap;
`

const Tag = styled(Link)<{ mode: string }>`
  color: ${({ mode }) => sys[mode].interaction.primary.default};
  text-decoration: underline;
`

const MAX_DISPLAY_COUNT = 2

type UserTagsProps = {
  className?: string
}

const UserTags = ({ className }: UserTagsProps) => {
  const displayTheme = useDisplayTheme()
  const { domain, photoUserTags } = useContextMediaDetail()
  const { t } = useTranslation()

  const hasMoreThanMaxDisplayCount = photoUserTags && photoUserTags?.length > MAX_DISPLAY_COUNT

  return (
    <Container className={className} mode={displayTheme}>
      {`${t('taggedUser_other')}:`}&nbsp;
      {photoUserTags?.slice(0, MAX_DISPLAY_COUNT).map((user, index) => {
        const isLastTag = index === Math.min(photoUserTags.length, MAX_DISPLAY_COUNT) - 1
        return (
          <React.Fragment key={user}>
            <Tag mode={displayTheme} href={getAuthorUrl(domain, user)}>
              {user}
            </Tag>
            {!isLastTag && <>{MessageConst.COMMA}&nbsp;</>}
            {isLastTag && hasMoreThanMaxDisplayCount && (
              <>&nbsp;{t('andOthers', { count: photoUserTags.length - MAX_DISPLAY_COUNT })}</>
            )}
          </React.Fragment>
        )
      })}
    </Container>
  )
}

export default UserTags
